import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { jsx } from 'react/jsx-runtime';

function SortIcon(props) {
  var order = props.order;
  if (order === 'asc') {
    var _jsx2;
    return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
      icon: "arrow-up",
      $color: "gray.400",
      $size: 12
    }, _jsx2["icon"] = faArrowUp, _jsx2));
  }
  if (order === 'desc') {
    var _jsx3;
    return /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx3 = {
      icon: "arrow-down",
      $color: "gray.400",
      $size: 12
    }, _jsx3["icon"] = faArrowDown, _jsx3));
  }
  return null;
}

export { SortIcon };
